import ImgixClient from "imgix-core-js";
import PropTypes from "prop-types";
import React from "react";
import imageCDNDomain from "lib/imageCDNDomain";

const IMGIX_SIZE_SPECS = { w: 324, h: 214, fit: "crop", auto: "format", q: 45 };

export default function ImgixImg({ src }) {
  const imgixClient = new ImgixClient({ domain: imageCDNDomain() });
  const imgixSrc = imgixClient.buildURL(src, IMGIX_SIZE_SPECS);

  return <img src={imgixSrc} alt="" />;
}

ImgixImg.propTypes = {
  src: PropTypes.string.isRequired,
};
